'use client'

import { type FC } from 'react'

import { ErxHub } from '../../../erx-hub'
import { RxLpMetas } from '../../components/RxLpMetas'

import { RxLpComHero } from './components/Hero/RxLpComHero'
import { RxLpComHowBonusIsCalculated } from './components/HowBonusIsCalculated/HowBonusIsCalculated'
import { RxLpComHowToRedeem } from './components/HowToRedeem/RxLpComHowToRedeem'
import { RxLpComNfcIsAvailableBanner } from './components/NfcIsAvailableBanner/NfcIsAvailableBanner'
import { RxLpComFaq } from './components/RxLpComFaq'
import { RxLpComFootnotes } from './components/RxLpComFootnotes'

export const RxComLandingPage: FC = () => {
  return (
    <>
      <RxLpMetas />
      <div className="mx-auto">
        <RxLpComHero />
        <RxLpComHowToRedeem />
        <RxLpComHowBonusIsCalculated />
        <RxLpComNfcIsAvailableBanner />
        <RxLpComFaq />
        <ErxHub />
        <RxLpComFootnotes />
      </div>
    </>
  )
}
